export default "__VITE_ASSET__BNz_Kacb__"